import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { authStore } from '@/stores/authStore';

const SSOCallback = observer(() => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const token = searchParams.get('token');
        if (!token) {
          throw new Error('No token provided');
        }

        // Handle the SSO token
        await authStore.handleSSOCallback(token);
        navigate('/dashboard');
      } catch (error) {
        console.error('SSO callback error:', error);
        navigate('/login');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto"></div>
        <p className="mt-2">Processing login...</p>
      </div>
    </div>
  );
});

export default SSOCallback; 